import { getFileType } from '@/plugins/fileType';
import { Element, ElementActionsPayload } from '@/store/types/element';
import { v4 as uuid } from 'uuid';

export const onDrop = async ({
  e,
  elPosition: mousePosition,
  uploadElement,
  afterUpload,
  addElement,
  fileList,
}: {
  e?: DragEvent;
  elPosition: { x: number; y: number };
  uploadElement: (payload: ElementActionsPayload['UPLOAD_ELEMENT']) => Promise<ElementActionsPayload['ADD_ELEMENT']>;
  addElement: (payload: ElementActionsPayload['ADD_ELEMENT']) => Promise<ElementActionsPayload['ADD_ELEMENT']>;
  afterUpload: (el: Element) => void;
  fileList?: FileList;
}) => {
  let text = '';
  let url = '';
  if (!fileList) {
    text = e?.dataTransfer?.getData('text/plain') || '';
    url = e?.dataTransfer?.getData('text/uri-list') || '';
  }

  const addImage = async (file: File, width: number, height: number, i: number) => {
    const { x, y } = mousePosition;
    const element = await uploadElement({
      file,
      element: {
        x: x + 10 * i,
        y: y + 10 * i,
        width,
        height,
        rotation: 0,
        deleted: false,
        data: {},
        type: 'Image',
      },
    });
    afterUpload(element);
  };
  const addAudio = async (file: File, i: number) => {
    const { x, y } = mousePosition;
    const element = await uploadElement({
      file,
      element: {
        x: x + 10 * i,
        y: y + 10 * i,
        width: 300,
        height: 56,
        rotation: 0,
        deleted: false,
        data: {},
        type: 'Audio',
      },
    });
    afterUpload(element);
  };
  const addVideo = async (file: File, i: number) => {
    const { x, y } = mousePosition;
    const element = await uploadElement({
      file,
      element: {
        x: x + 10 * i,
        y: y + 10 * i,
        width: 0,
        height: 0,
        rotation: 0,
        deleted: false,
        data: {},
        type: 'Video',
      },
    });
    afterUpload(element);
  };
  const addPdf = async (file: File, i: number) => {
    const { x, y } = mousePosition;
    const element = await uploadElement({
      file,
      element: {
        x: x + 10 * i,
        y: y + 10 * i,
        width: 595,
        height: 842,
        rotation: 0,
        deleted: false,
        data: {
          pages: 0,
          currentPage: 1,
        },
        type: 'Pdf',
      },
    });

    afterUpload(element);
  };
  const addOffice = async (file: File, i: number) => {
    const { x, y } = mousePosition;
    const element = await uploadElement({
      file,
      element: {
        x: x + 10 * i,
        y: y + 10 * i,
        width: 595,
        height: 842,
        rotation: 0,
        deleted: false,
        data: {
          pages: 0,
          currentPage: 1,
        },
        type: 'Office',
      },
    });

    afterUpload(element);
  };
  const addText = async (text: string, i: number) => {
    const { x, y } = mousePosition;
    const element = await addElement({
      x: x + 10 * i,
      y: y + 10 * i,
      width: 0,
      height: 0,
      rotation: 0,
      deleted: false,
      data: {
        text,
      },
      type: 'Text',
    });

    afterUpload(element);
  };

  const blobToFile = (blob: Blob, fileName: string) => {
    return new File([blob], fileName, { lastModified: new Date().getTime() });
  };

  if (url) {
    const req = await fetch(url);
    const blob = await req.blob();
    const fileType = await getFileType(blob);
    if (fileType.type === 'image' && fileType.supported) {
      const image = new Image();
      image.onload = async function() {
        const fileName = uuid() + fileType.extension;
        const file = blobToFile(blob, fileName);
        addImage(file, (this as HTMLImageElement).width, (this as HTMLImageElement).height, 0);
      };
      image.src = url;
    }
  } else if (text) {
    addText(text, 0);
  } else if (fileList || e?.dataTransfer?.files) {
    const files = fileList || e?.dataTransfer?.files || [];
    Array.from(files).forEach(async (file, i) => {
      const fileType = await getFileType(file);
      if (!fileType.supported) return;
      if (fileType.type === 'image') {
        const image = new Image();
        const reader = new FileReader();
        reader.onload = function(e) {
          image.onload = function() {
            addImage(file, (this as HTMLImageElement).width, (this as HTMLImageElement).height, i);
          };
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          image.src = (e.target as any).result;
        };
        reader.readAsDataURL(file);
      } else if (fileType.type === 'pdf') {
        // const url = URL.createObjectURL(file);
        addPdf(file, i);
      } else if (fileType.type === 'text') {
        const reader = new FileReader();
        reader.onload = function(e) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          addText((e.target as any).result, i);
        };
        reader.readAsText(file);
      } else if (fileType.type === 'audio') {
        addAudio(file, i);
      } else if (fileType.type === 'video') {
        addVideo(file, i);
      } else if (fileType.type === 'office') {
        addOffice(file, i);
      }
    });
  }
};
